import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField } from "helpers/row-logic-helper";
import { get } from "lodash";

import { shouldShowField } from "../loanDetailEditUtil";

import { propertyAllocationMapNested } from "./section-loan-property-allocations-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  lenders: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Allocations",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT_NESTED,
        mapNestedRows: data => propertyAllocationMapNested(data),
        map: data => defaultField(data, "name"),
        Cell: tableSideColumnMapper,
        subtextMappers: [,
          { map: row => get(row, "allocated") }]
      }
    ]
  }
};
